module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/chapel-suns_access_03-0d3af52da520f892a9d74ec5ed494bd1.jpg";